import { render } from "./SimilarTyres.vue?vue&type=template&id=11c101b0"
import script from "./SimilarTyres.vue?vue&type=script&lang=js"
export * from "./SimilarTyres.vue?vue&type=script&lang=js"

import exportComponent from "/data/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__